module.exports = __webpack_public_path__ + "siteBanner_img_ov.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/temp/siteBanner_img_ov.jpg?v=3
// module id = 1863
// module chunks = 0